import { render, staticRenderFns } from "./stockParts.vue?vue&type=template&id=b7004d2e&scoped=true&"
import script from "./stockParts.vue?vue&type=script&lang=js&"
export * from "./stockParts.vue?vue&type=script&lang=js&"
import style0 from "./stockParts.vue?vue&type=style&index=0&id=b7004d2e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7004d2e",
  null
  
)

export default component.exports